<template>
  <div class="lawsjxflzs between">
    <div class="jxf_left">
      <sub-title text="精选法律知识" />

      <div class="content">
        <div class="jxfl_top between">
          <div class="jxfl_tl">
            <el-carousel
              :interval="3000"
              height="252px"
              ref="jxfl_tlswi"
              arrow="never"
              indicator-position="none"
              @change="swichan"
            >
              <el-carousel-item v-for="(item, index) in swilist" :key="index" @click.native="tojump(item)">
                <img :src="item.preview_pic" class="img" />
              </el-carousel-item>
            </el-carousel>
            <div class="jxfl_tl_num flex_end">
              <div
                v-for="(item, index) in swilist"
                :key="index"
                :class="{ active: swi_act == index }"
                @click="setswi(index)"
              >
                {{ index + 1 }}
              </div>
            </div>
          </div>
          <div class="jxfl_tr">
            <div class="trtop" v-if="swirl[0]" @click="tojump(swirl[0])">
              <div class="ti ellipsis" >
                {{swirl[0].title}}
              </div>
              <div class="de">
                {{
                  swirl[0].content  | toEllipsisFilter(45)
                }}
              </div>
            </div>
            <div class="trbtm between">
              <div class="btmitem" v-for="(item,index) in swirl.slice(1)" :key="index" @click="tojump(item)">
                <img :src="item.preview_pic" />
                <div class="trtext ellipsis">{{item.title}}</div>
              </div>

            </div>
          </div>
        </div>
        <div class="jxfl_bottom between wrap">
          <div
            class="tjitem flex_start"
            v-for="(item, index) in swiboml"
            :key="index"
            @click="tojump(item)"
          >
            <span>{{item.tag}}</span>{{item.title}}
          </div>
        </div>
      </div>
    </div>
    <div class="jxf_right">
      <div class="between">
        <sub-title text="热门标签" />
        <div class="hottag_hyp flex_end">
          <img src="../../../assets/laws/huanyipi.png" /> 换一批
        </div>
      </div>
      <div class="taglist">
        <div class="flex_start wrap">
          <div class="taglitem">羁押期限</div>
          <div class="taglitem">羁押期限</div>
          <div class="taglitem">无固定期限劳动合同</div>
          <div class="taglitem">羁押期限</div>
          <div class="taglitem">无固定期限劳动合同</div>
          <div class="taglitem">羁押期限</div>
        </div>
      </div>

      <div class="advlist">
        <law-card
          v-for="(item, index) in 2"
          :key="index"
          :isudflo="index != 1"
          class="advitem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";
import lawCard from "../components/lawCard";
export default {
  components: {
    subTitle,
    lawCard,
  },
  data: () => ({
    swi_act: 0,
    swilist: [],
    swirl: [],
    swiboml: [],
  }),
  beforeMount() {
    this.getswi();
    this.gettopnew();
    this.getbomnew();
  },
  methods: {
    swichan(index) {
      this.swi_act = index;
    },
    setswi(index) {
      this.$refs.jxfl_tlswi.setActiveItem(index);
    },
    getswi() {
      this.$http.laws
        .getnewslist({
          limit: 4,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this["swilist"] = res.data.data;
        });
    },
    gettopnew() {
      this.$http.laws
        .getnewslist({
          limit: 3,
          order: "hot",
          page: 2,
        })
        .then((res) => {
          this["swirl"] = res.data.data;
        });
    },
    getbomnew() {
      this.$http.laws
        .getnewslist({
          limit: 6,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this["swiboml"] = res.data.data;
        });
    },
       tojump(current) {
      this.$router.push({
        path: "/laws/specialdet",
        query: {
          lawonId: current.id,
        },
      });
    },
  },

};
</script>

<style lang="scss" scope>
.lawsjxflzs {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  background-color: #fff;
  .jxf_left {
    width: 810px;
    height: 100%;
    .content {
      margin-top: 28px;
      .jxfl_top {
        width: 100%;
        height: 252px;
        align-items: flex-start;
        .jxfl_tl {
          width: 344px;
          height: 252px;
          position: relative;
          .img {
            width: 344px;
            height: 252px;
          }
          .jxfl_tl_num {
            position: absolute;
            bottom: 8px;
            right: 11px;
            z-index: 3;
            div {
              cursor: pointer;
              width: 18px;
              height: 18px;
              line-height: 18px;
              text-align: center;
              background: rgba($color: #999797, $alpha: 0.59);
              font-size: 12px;
              margin-right: 3px;
              color: #ffffff;
            }
            .active {
              background-color: #0465ea;
            }
          }
        }
        .jxfl_tr {
          width: 440px;
          padding-top: 20px;
          .trtop {
            padding-bottom: 14px;
            cursor: pointer;
            &:hover {
              .ti {
                color: #0465ea;
              }
            }
            .ti {
              font-size: 20px;
              color: #333;
            }
            .de {
              margin-top: 10px;
              font-size: 15px;
              line-height: 24px;
              color: #999999;
            }
          }
          .trbtm {
            .btmitem {
              position: relative;
              img {
                width: 215px;
                height: 134px;
              }
              .trtext {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                font-size: 14px;
                padding: 5px 8px;
                color: #fff;
                background-color: rgba(0, 0, 0, 0.4);
              }
            }
          }
        }
      }
      .jxfl_bottom {
        margin-top: 20px;
        width: 100%;
        .tjitem {
          width: 390px;
          margin: 10px 0;
          cursor: pointer;
          &:hover {
            color: #0465ea;
          }
          span {
            color: #999999;
            padding-right: 15px;
            margin-right: 15px;
            border-right: 1px solid #eee;
          }
        }
      }
    }
  }
  .jxf_right {
    width: 370px;
    height: 100%;
    .hottag_hyp {
      cursor: pointer;
      font-size: 14px;
      color: #0465ea;
      img {
        margin-right: 8px;
      }
    }
    .taglist {
      width: 100%;
      height: 146px;
      margin-top: 17px;
      align-items: flex-start;
      overflow: hidden;
      .taglitem {
        padding: 8px 18px;
        margin-right: 15px;
        margin-top: 13px;
        font-size: 14px;
        background: #f4f9ff;
        border-radius: 5px;
      }
    }
    .advlist {
      width: 100%;
      margin-top: 32px;
      .advitem {
        margin-top: 16px;
      }
    }
  }
}
</style>